import { callFetch } from './serviceHelpers';

export const getFulfillmentExpectationView = fulfillmentConfigurationUrl =>
  callFetch(
    process.env.REACT_APP_FULFILLMENT_EXPECTATIONS_URL,
    'GET',
    `v4/views/support?fulfillmentConfigurationUrl=${fulfillmentConfigurationUrl}`
  );
